import type { UseMutationOptions } from '@tanstack/react-query';
import { mutationOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type {
  CancelBnplIntentPayload,
  CancelBnplIntentResponse,
} from './types';

async function cancelBnplIntent({
  paymentIntentId,
  cartId,
}: CancelBnplIntentPayload): Promise<CancelBnplIntentResponse> {
  try {
    const { data } = await apiClient.post<CancelBnplIntentResponse>(
      `/v1/payment/bnpl-intent/${paymentIntentId}/cancel`,
      { cartId },
    );
    return data;
  } catch (error) {
    Logger.error('Failed to cancel BNPL payment intent', {
      error,
      paymentIntentId,
      cartId,
    });
    throw error;
  }
}

export const cancelBnplIntentMutation = (
  options?: UseMutationOptions<
    CancelBnplIntentResponse,
    Error,
    CancelBnplIntentPayload
  >,
) =>
  mutationOptions({
    mutationFn: cancelBnplIntent,
    mutationKey: ['cancelBnplIntent'],
    retry: false,
    ...options,
  });
